import { render, staticRenderFns } from "./TransportationPrice.vue?vue&type=template&id=3fb1d396&scoped=true&"
import script from "./TransportationPrice.vue?vue&type=script&lang=js&"
export * from "./TransportationPrice.vue?vue&type=script&lang=js&"
import style0 from "./TransportationPrice.vue?vue&type=style&index=0&id=3fb1d396&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb1d396",
  null
  
)

export default component.exports